import { type FC } from 'react';
import { graphql, useFragment } from 'react-relay';

// components
import {
    SbSharedRefineMenuMultiSelect,
    type FilterValue,
} from '../SbSharedRefineMenuMultiSelect/SbSharedRefineMenuMultiSelect.tsx';
import { SbSharedRefineMenuTypeaheadContainer } from '../SbSharedRefineMenuTypeahead/SbSharedRefineMenuTypeaheadContainer.tsx';

import { type SbSharedRefineMenuMultiSelectSearch_viewer$key } from './__generated__/SbSharedRefineMenuMultiSelectSearch_viewer.graphql.ts';
import { type SbSharedRefineMenuMultiSelectSearch_itemSearch$key } from './__generated__/SbSharedRefineMenuMultiSelectSearch_itemSearch.graphql.ts';

const viewerFragment = graphql`
    fragment SbSharedRefineMenuMultiSelectSearch_viewer on Viewer {
        ...SbSharedRefineMenuTypeaheadContainer_viewer
    }
`;
const itemSearchFragment = graphql`
    fragment SbSharedRefineMenuMultiSelectSearch_itemSearch on ItemSearchQueryConnection {
        ...SbSharedRefineMenuTypeaheadContainer_itemSearch
        ...SbSharedRefineMenuMultiSelect_itemSearch
    }
`;

type Props = {
    viewer: SbSharedRefineMenuMultiSelectSearch_viewer$key;
    itemSearch: SbSharedRefineMenuMultiSelectSearch_itemSearch$key;
    collapsedItemCount?: number;
    filterName: string;
    showSearchBar?: boolean;
    trackingOptions?: Record<string, unknown>;
    values: FilterValue[];
};

export const SbSharedRefineMenuMultiSelectSearch: FC<Props> = ({
    viewer: viewerRef,
    itemSearch: itemSearchRef,
    values,
    filterName,
    collapsedItemCount,
    showSearchBar,
    trackingOptions,
}) => {
    const viewer = useFragment(viewerFragment, viewerRef);
    const itemSearch = useFragment(itemSearchFragment, itemSearchRef);

    return (
        <SbSharedRefineMenuTypeaheadContainer
            viewer={viewer}
            itemSearch={itemSearch}
            filterName={filterName}
            availableFilterValues={values}
            collapsedItemCount={collapsedItemCount}
            showSearchBar={showSearchBar}
            trackingOptions={trackingOptions}
        >
            {({ valuesToShow }) => (
                <SbSharedRefineMenuMultiSelect
                    itemSearch={itemSearch}
                    filterName={filterName}
                    valuesToShow={valuesToShow}
                    trackingOptions={trackingOptions}
                />
            )}
        </SbSharedRefineMenuTypeaheadContainer>
    );
};
